export default "__VITE_ASSET__ecd66562__"